export const irNamePattern: string = '^[A-Za-z0-9]+(?:-[A-Za-z0-9]+)*$';
export const base64Pattern: string = '^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$';
export const irNameMinLength = 3;
export const irNameMaxLength = 63;
export const irListRefreshInterval = 300000;
export const irListRefreshMinInterval = 240000;
export const irNodeRefreshInterval = 30000;
export const irDefaultInstanceName = 'AutoResolveIntegrationRuntime';
export const emptyGuid = '00000000-0000-0000-0000-000000000000';
export const irStartingStuckMs = 1620000; // 27 minutes
export const irStoppingStuckMs = 480000; // 8 minutes
export const defaultAutoTerminationMinutes = 60;
export const autoTerminationMinutesUpperBound = 10000;
export const autoTerminationMinutesLowerBound = 10;
export const defautlCopyComputeScaleTTLMinutes = 5;
export const defaultCopyComputeScaleDIUNumber = 16;
export const minCopyComputeScaleDIUNumber = 4;
export const maxCopyComputeScaleDIUNumber = 256;
export const copyComputeScaleDIUStep = 4;
export const defaultCopyComputeScaleDIUValue = 'small';
export const minPipelineComputeScaleDIUNumber = 1;
export const maxPipelineComputeScaleDIUNumber = 10;
export const pipelineComputeScaleDIUStep = 1;
export const defaultPipelineComputeScaleDIUValue = 'small';
export const minExternalComputeScaleDIUNumber = 1;
export const maxExternalComputeScaleDIUNumber = 10;
export const externalComputeScaleDIUStep = 1;
export const defaultExternalComputeScaleDIUValue = 'small';
export const defautPipelineAndExternalComputeScaleTTLMinutes = 60;

export type irCreateType = 'Managed' | 'Linked' | 'SelfHosted' | 'Azure' | 'SSIS' | 'AzureSSIS' | 'AzureVNet' | 'ManagedVNet' | 'Emulator' | 'AzureSSISShared' | 'AzureSSISLinked';

export type meterType = 'SelfhostedIR' | 'AzureIR' | 'General';

export type semanticScaleType = 'small' | 'medium' | 'large' | 'custom';

export const allowedADFCDCIRTypes: irCreateType[] = ['Managed', 'Azure', 'AzureVNet', 'ManagedVNet'];

export enum irUIFetchDataStatus {
    Fetching,
    EmptyResult,
    Succeeded,
    Error
}

export const irScenarioTypesConst = {
    DataMovement: 'dataMovement',
    SSIS: 'SSIS',
    SSISExpress: 'SSISExpress',
    Airflow: 'Airflow'
};

export const irSourceTypesConst = {
    Madrid: 'Madrid',
    DeployWizard: 'DeployWizard',
    MIPortal: 'MIPortal',
    SQLPortal: 'SQLPortal'
};

export const irTypesConst = {
    SelfHosted: 'SelfHosted' as irCreateType,
    Linked: 'Linked' as irCreateType,
    Managed: 'Managed' as irCreateType,
    Azure: 'Azure' as irCreateType,
    SSIS: 'SSIS' as irCreateType,
    AzureSSIS: 'AzureSSIS' as irCreateType,
    ManagedVNet: 'ManagedVNet' as irCreateType,
    Emulator: 'Emulator' as irCreateType,
    Airflow: 'Airflow' as irCreateType,
    AzureSSISShared: 'AzureSSISShared' as irCreateType,
    AzureSSISLinked: 'AzureSSISLinked' as irCreateType,
    AzureVNet: 'AzureVNet' as irCreateType
};

export const meterTypesConst = {
    SelfhostedIR: 'SelfhostedIR' as meterType,
    AzureIR: 'AzureIR' as meterType,
    General: 'General' as meterType
};

export const irStatusConst = {
    Unknown: 'Unknown',
    NeedRegistration: 'NeedRegistration',
    Online: 'Online',
    Limited: 'Limited',
    Inactive: 'Inactive',
    Offline: 'Offline',
    Upgrading: 'Upgrading',
    Initializing: 'Initializing',
    InitializeFailed: 'InitializeFailed',
    Initial: 'Initial',
    Stopped: 'Stopped',
    Stopping: 'Stopping',
    Starting: 'Starting',
    Started: 'Started',
    Available: 'Available',
    Recycling: 'Recycling',
    Unavailable: 'Unavailable',
    Refreshing: 'Refreshing',
    Updating: 'Updating',
    Unauthorized: 'Unauthorized',
    Succeeded: 'Succeeded',
    Failed: 'Failed',
    Provisioning: 'Provisioning',
    ProvisionFailed: 'ProvisionFailed',
    ProvisionSucceeded: 'ProvisionSucceeded',
    NotExist: 'NotExist',
    NotFound: 'NotFound',
    Running: 'Running'
};

export const shirInLimitedReasonConst = {
    Unknown: 'Unknown',
    ServiceBusConnectionError: 'ServiceBusConnectionError'
};

export const irVersionStatusConst = {
    None: 'None',
    UpToDate: 'UpToDate',
    Expiring: 'Expiring',
    Expired: 'Expired',
    UpdateAvailable: 'UpdateAvailable'
};

export const vnetConst = {
    networkSecurityGroup: {
        Any: '*',
        Internet: 'Internet',
        VirtualNetwork: 'VirtualNetwork',
        AzureCloud: 'AzureCloud',
        BatchNodeManagement: 'BatchNodeManagement',
        Allow: 'Allow',
        Deny: 'Deny',
        Inbound: 'Inbound',
        Outbound: 'Outbound',
        TCP: 'TCP',
        Sql: 'Sql'
    },
    routeTable: {
        Internet: 'Internet'
    },
    subnet: {
        GatewaySubnet: 'GatewaySubnet',
        AzureFirewallSubnet: 'AzureFirewallSubnet',
        AzureBastionSubnet: 'AzureBastionSubnet',
        serviceEndPoint: {
            sqlServiceEndPoint: 'Microsoft.Sql'
        }
    },
    lock: {
        NotSpecified: 'NotSpecified',
        CanNotDelete: 'CanNotDelete',
        ReadOnly: 'ReadOnly'
    },
    policy: {
        If: 'if',
        Not: 'not',
        AllOf: 'allOf',
        AnyOf: 'anyOf',
        Equals: 'equals',
        Like: 'like',
        Match: 'match',
        Contains: 'contains',
        In: 'in',
        Field: 'field',
        Source: 'source',
        Type: 'type',
        Then: 'then',
        Effect: 'effect',
        Deny: 'deny'
    },
    subnetDelegationService: {
        batchAccount: 'Microsoft.Batch/batchAccounts'
    }
};

export const irVNetModeTypes = {
    Standard: 'Standard',
    Express: 'Express'
};

export interface IIRCapabilities {
    connectedToResourceManager?: string;
    credentialInSync?: string;
    httpsPortEnabled?: string;
    nodeEnabled?: string;
    serviceBusConnected?: string;
    dotNetVersion?: string;
    noEnoughDiskSpace?: string;
}

export interface IGetStatusResult<T> {
    status: string;
    result?: T;
}

export interface ISort {
    sortColumn: string;
    sortOrder: number;
}

export interface IVNetValidationResult {
    level: string;
    errors: IVNetValidationMessage[];
    warnings: IVNetValidationMessage[];
}

export interface IVNetValidationMessage {
    category: string;
    message: string;
    referenceLink?: string;
}

export interface ILinkedDataFactoryContract {
    dfName: string;
    dfPrincipleId: string;
    roleAssignmentId: string;
    isDFRow: boolean;
    invalidDf?: boolean;
    emptyIrRow?: boolean;
    irName?: string;
    irCreateTime?: string;
    dfWithoutRoleAssignment?: boolean;
    dfKeyAuth?: boolean;
    description?: string;
    resourceType?: string;
}

export const vnetValidationResultLevel = {
    Pass: 'Pass',
    Error: 'Error',
    Warning: 'Warning'
};

export const vnetValidationMessageCategory = {
    InternalError: 'InternalError',
    GetResourceFailed: 'GetResourceFailed',
    NetworkSecurityGroupDenyPort: 'NetworkSecurityGroupDenyPort',
    RouteTableNextHopNotInternet: 'RouteTableNextHopNotInternet',
    GatewaySubnet: 'GatewaySubnet',
    AzureFirewallSubnet: 'AzureFirewallSubnet',
    AzureBastionSubnet: 'AzureBastionSubnet',
    SubnetDelegateService: 'SubnetDelegateService',
    ExternalResourceConflict: 'ExternalResourceConflict',
    InsufficientIpAddressSpace: 'InsufficientIpAddressSpace',
    CustomDns: 'CustomDns',
    ResourceGroupLock: 'ResourceGroupLock',
    ResourceGroupPolicyDeny: 'ResourceGroupPolicyDeny',
    InsufficientIpAddressPrefix: 'InsufficientIpAddressPrefix',
    SubscriptionLock: 'SubscriptionLock',
    InvalidPublicIPCount: 'InvalidPublicIPCount',
    SamePublicIPs: 'SamePublicIPs',
    UnmatchedSqlVNetSubnet: 'UnmatchedSqlVNetSubnet',
    UnmatchedSqlFirewall: 'UnmatchedSqlFirewall'
};
